import React from 'react';
import "./main-container-component.css";

const MainContainer = (
  {
   children
  }
) => {
  return (
    <div className="main_container">
      <div style={{width: '300px'}} />
      <div className="main_container__data">
      { children }
      </div>
    </div>
  )
};


export default MainContainer;


// WEBPACK FOOTER //
// ./src/components/main-container/main-container-component.js